import {initHeader} from './header';
import {initSectionExpandingText} from "./section.expanding-text";
import {initSectionComplexCard} from "./section.complex-card";
import {initSlideshowComponent} from './section.slideshow-component';
import {initSlideshowFull} from "./section.slideshow-full";
import { initChooser } from './section.chooser';
import {initSectionSlideshowIndex} from "./section.slideshow-index";
import {initCarousel} from './section.carousel';
import {initSectionInfrastructure} from "./section.infrastructure";
import {initObjects} from './section.objects';
import {initCardsSocial} from './section.cards-social';
import {initCalculatorMortgage} from './section.calculator-mortgage';
import {initArticleCard} from "./article.card";
import {initAsideSidebar} from "./aside.sidebar";
import {initSectionContacts} from "./section.contacts";
import {initConstructionProgress} from './section.construction-progress';
import {initConstructionProgressContent} from './section.construction-progress-content';
import {initStories} from './section.stories';
import {initSectionChooserParkinChooserStorage} from './section.chooser-parking,section.chooser-storage';
import {initFeed} from './section.feed';
import {initSectionVideo} from './section.video';
import {initPayButton} from './section.pay-button';
import {initSectionTable} from './section.table';
import {initSlideshowFurniture} from './section.furniture';
import {initPayBack} from './section.payback-calculator';

export const initComponents = () => {
	initHeader();
	initSectionExpandingText();
	initSectionComplexCard();
	initSlideshowComponent();
	initSlideshowFull();
	initChooser();
	initSectionSlideshowIndex();
	initCarousel();
	initSectionInfrastructure();
	initObjects();
	initCardsSocial();
	initCalculatorMortgage();
	initArticleCard();
	initAsideSidebar();
	initSectionContacts();
	initConstructionProgress();
	initConstructionProgressContent();
	initStories();
	initSectionChooserParkinChooserStorage();
	initFeed();
	initSectionVideo();
	initPayButton();
	initSectionTable();
	initSlideshowFurniture();
	initPayBack();
};
